import React from "react";
import RouterLink from "gatsby-link";
import styled from "styled-components";

const Arrow = () => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22 12l-4-4v3H3v2h15v3z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

const Project = ({ pathContext }) => {
  const { title, subtitle, description, image, website = null } = pathContext;

  return (
    <StyledProject>
      <StyledImage src={`/${image}.svg`} alt="" />
      <Contents>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        <Description>{description}</Description>
        {website === null ? null : (
          <ExternalLink href={website}>
            <Span>visit website</Span> <Arrow />
          </ExternalLink>
        )}
      </Contents>
    </StyledProject>
  );
};

const ExternalLink = styled.a`
  color: var(--link-color);
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all 0.1s ease;
  display: inline-flex;
  padding-bottom: 0.1em;
  &:hover,
  &:focus {
    border-bottom: 2px solid var(--link-color);
  }
`;

const Span = styled.span`
  margin-right: 0.2em;
`;

const StyledProject = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const Contents = styled.div`
  flex: 1 1 20em;
  max-width: 30em;
  margin-left: 1em;
`;

const Title = styled.h1`
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 0.8em;
  margin: 0;
`;

const Description = styled.p``;

const StyledImage = styled.img`
  flex: 1 1 10em;
  max-width: 100%;
  @media (min-width: 600px) {
    max-width: 25em;
  }
`;

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project/index.js